import {
  LOCALHOST_TURNSTILE_SITE_KEYS,
  PROD_HOST,
  TURNSTILE_DEVSTAGE_LOCALSTORAGE_KEY,
} from '../consts'
import { TURNSTILE_SITE_KEY } from '../../../utils/consts.mjs'

const { port, host } = window.location

/**
 * Determines the appropriate turnstile site key based on the application's environment.
 * This function employs several strategies to select the correct site key:
 * 1. Checks if the application is running on localhost by examining the port number.
 *    If true, it returns a predefined site key suitable for localhost testing.
 * 2. Verifies if the application is hosted on the production server by comparing the host against the known production host.
 *    If the condition is met, it then checks for the presence of a devstage site key stored in local storage.
 *    If found, it returns the corresponding devstage site key.
 * 3. Fallback to the production site key if none of the above conditions are met.
 *
 * @function getTurnstileSitekey
 * @returns {string} The site key configured for the turnstile challenge, chosen based on the application's environment.
 */
export const getTurnstileSitekey = () => {
  // Directly returning the localhost site key if the application is running on port 3000, indicating localhost.
  if (port === '3000') return LOCALHOST_TURNSTILE_SITE_KEYS.PASSES_VISIBLE

  // Attempt to retrieve the devstage site key from local storage.
  const turnstileDevstageLocalstorageKey =
    localStorage.getItem(TURNSTILE_DEVSTAGE_LOCALSTORAGE_KEY) || ''

  // Conditional logic to determine the appropriate site key:
  // - Not running on the production host AND
  // - Devstage site key exists in local storage AND
  // - The retrieved key matches a predefined localhost key.
  if (
    host !== PROD_HOST &&
    turnstileDevstageLocalstorageKey &&
    LOCALHOST_TURNSTILE_SITE_KEYS[turnstileDevstageLocalstorageKey]
  ) {
    return LOCALHOST_TURNSTILE_SITE_KEYS[turnstileDevstageLocalstorageKey]
  }

  // Default fallback to the production site key if no specific conditions are met.
  return TURNSTILE_SITE_KEY
}
